import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./CreateBill.module.css";
import Header from "../Header/Header";
import CustomSingleSelect from "../Common/CustomeSingleSelect";
import { Tooltip, Paragraph, TextInput, TextareaField } from "evergreen-ui";
import { useNavigate, useLocation } from "react-router-dom";
import { IMAGE_PATH } from "../../Utils/variables";
import CustomButton from "../Common/CustomButton";
import { toast, ToastContainer } from "react-toastify";
import CategorySelect from "../Common/CategorySelect";
let counter = 2;

const CreateBill = () => {  
  const navigate = useNavigate();
  const location = useLocation();
  const poId = location.state?.poNumber;
  const billId = location.state?.billId;
  const today = new Date().toISOString().split("T")[0];
  const commID = location.state?.commId;
  const filePickerRef = useRef(null);
  const [showPoInput, setShowPoInput] = useState(location.state?.hide);
  const { vendorId, vendorName,  userId} = useSelector((state) => state.auth);
  const [poNumner, setPoNumber] = useState("");
  const [communitiesList, setCommunitiesList] = useState([]);
  const [selectedCommunityOption, setSelectedCommunityOption] = useState(null);
  const [billNumber, setBillNumber] = useState("");
  const [billDate, setBillDate] = useState("");
  const [comment, setComment] = useState("");
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [documentUploading, setDocumentUploading] = useState(false);
  const [uomList, setUomList] = useState([]);
  const [selectedUom, setSelectedUom] = useState()
  const [leftPoAmount, setLeftPoAmount] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [errorsArray, setErrorsArray] = useState([]);
  const [editApiAttachments, setEditApiAttachments] = useState([]);
  const [expenseCategoryList, setExpenseCategoryList] = useState([]);
  const [notes, setNotes] = useState("");
  const [initialLoader, setInitialLoader] = useState(false);
  const [purchaseOrderId, setPurchaseOrderId] = useState("");
  const [selectableCategories, setSelectableCateories] = useState([]);
  const [billTimeStamp, setBillTimeStamp] = useState('')
  const [categoryAvailableQty, setCategoryAvailableQty] = useState({})
  const [categoryNames, setCategoryNames] = useState({})
  const MAX_FILE_SIZE_MB = "25";
  const item = {
    poItemId: '',
    expenseCategory: "",
    itemName: "",
    uom: "",
    quantity: "",
    unitPrice: "",
    discountAmount: "",
    totalUnitPrice: "",
    vat: "",
    vatAmount: "",
    totalPrice: "",
    remainQty: "",
  };
  const [itemDetails, setItemDetails] = useState([
    {
      id: 1,
      ...item,
    },
  ]);

  const getDecimalValues = (number) => {
    const parsedNumber = parseFloat(number);
    if (Number.isNaN(parsedNumber)) {
      return "";
    }
    const communityRoundOff = selectedCommunityOption?.roundOffNumber;
    const roundeOffValue =
      communityRoundOff != null && communityRoundOff !== ""
        ? Number(communityRoundOff)
        : 2;
    const multiplier = Math.pow(10, roundeOffValue);
    const roundedValue =
      Math.round((parsedNumber + Number.EPSILON) * multiplier) / multiplier;
    return roundedValue.toFixed(roundeOffValue);
  };

  const computeBillTotalsFromLines = (lines) => {
    let vatTotal = 0;
    let discountTotal = 0;
    let subTotal = 0;
    let grandTotal = 0;
    lines.forEach((each) => {
      if (each?.quantity && each?.unitPrice) {
        vatTotal += Number(each.vatAmount) || 0;
        discountTotal += Number(each.discountAmount) || 0;
        subTotal += Number(each.totalUnitPrice) || 0;
        grandTotal += Number(each.totalPrice) || 0;
      }
    });
    return {
      billVatAmount: getDecimalValues(vatTotal),
      billDiscountAmount: getDecimalValues(discountTotal),
      billSubAmount: getDecimalValues(subTotal),
      grandTotal: getDecimalValues(grandTotal),
    };
  };

  const billTotals = useMemo(
    () => computeBillTotalsFromLines(itemDetails),
    [itemDetails, selectedCommunityOption?.roundOffNumber]
  );

  const onChangeItemDetails = (e, id) => {
    const name = e.target.name;
    if (name === "itemName") {
      const updatedArray = itemDetails.map((each) => {
        if (id === each.id) {
          return { ...each, [name]: e.target.value.trimStart() };
        } else {
          return each;
        }
      });
      setItemDetails(updatedArray);
    } else {
      let value = e.target.value;
      if(name == 'vat'){
        if(value > 100){
          toast.error('Vat% can not be greater than 100%')
          value = "100"
        }
      }
      if (value !== "" && !/^-?\d*\.?\d*$/.test(value)) return;
      const updatedArray = itemDetails.map((each) => {
        if (id === each.id) {
          if (name == "quantity") {
            let parsedValue = value;
            if (parsedValue != "") {
              parsedValue = parseInt(parsedValue);
            }
            
            if ((each.remainQty != "" && parsedValue > each.remainQty) && showPoInput) {
              toast.error(`Maximum quantity allowed is ${each.remainQty}`);
              parsedValue = each.remainQty;
            }
            return { ...each, [name]: parsedValue };
          }else {
            let parsedValue = value;

            if (parsedValue && selectedCommunityOption?.roundOffNumber) {
              parsedValue = parseFloat(value).toFixed(
                selectedCommunityOption?.roundOffNumber
              );
            }

            const countDecimals = value?.split(".")?.[1]?.length;

            if (countDecimals > selectedCommunityOption?.roundOffNumber) {

              return {
                ...each,
                [name]: parsedValue,
              };
            }
            return { ...each, [name]: value };
          }
        } else {
          return each;
        }
      });
      const calculatedData = calculatedItemDetails(updatedArray);
      setItemDetails(calculatedData);
    }
  };

  const calculatedItemDetails = (data) => {
    const result = data.map((each) => {
      const quantity = each?.quantity;
      let discount = each?.discountAmount;
      const unitPrice = each?.unitPrice;
      let totalUnitPrice = each?.totalUnitPrice;
      const vatPercentage = each?.vat;
      let totalPrice = 0;
      let vatAmount = 0;
      if (quantity && unitPrice) {
        totalUnitPrice = quantity * unitPrice;
        if (discount > 0 && quantity > 0) {
          if (totalUnitPrice - discount < 0) {
            toast.error(
              "Discount amount can not be greater than total unit price"
            );
            discount = 0;
          } else if (totalUnitPrice - discount == 0) {
            toast.error("Discount amount can not be equal to total unit price");
            discount = 0;
          } else {
            totalUnitPrice = totalUnitPrice - discount;
          }
        }
        totalPrice = totalUnitPrice;
        if (vatPercentage) {
          vatAmount = (vatPercentage / 100) * totalPrice;
          totalPrice = totalPrice + vatAmount;
        }
        return {
          ...each,
          vat: each.vat,
          discountAmount: discount,
          totalUnitPrice: getDecimalValues(totalUnitPrice),
          vatAmount: getDecimalValues(vatAmount),
          totalPrice: getDecimalValues(totalPrice),
        };
      } else {
        return each;
      }
    });

    return result;
  };

  const onChangeUOMAndCategory = (selected, id, name) => {
    const selectedItem = itemDetails.filter(item => item.expenseCategory?.id == selected?.id)
    if(selectedItem.length > 0){
      toast.error("Category already in use. Please select another option.")
      return
    }
    const updatedArray = itemDetails.map((each) => {
      if (id === each?.id) {
        return { ...each, [name]: selected };
      } else {
        return each;
      }
    });
    setItemDetails(updatedArray);
  };

  function createId() {
    return counter++;
  }


  const plusAddItemDetails = () => {
    if (showPoInput) return;
    const newItem = {
      id: createId(),
      ...item,
      uom: selectedUom?.name ? selectedUom: '',
    };
    setItemDetails([...itemDetails, newItem]);
  };

  const getMappedCommunities = () => {
    const payload = {
      vendor_id: vendorId,
    };
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/mapped_communities", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((res) => {
        const formattedComm = res?.response?.map((each) => {
          return {
            id: each.community_id,
            name: each.community_name,
            roundOffNumber: each.rounding_off_value,
          };
        });
        setCommunitiesList(formattedComm);
      })
      .catch((err) => console.log("e", err));
  };

  const getExpenseCategory = () => {
    const payload = {
      community_id: selectedCommunityOption?.id,
    };
    fetch(
      process.env.REACT_APP_API_URL + "/api/vendorpo/fetchExpenseCategory",
      {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "content-type": "application/json" },
      }
    )
      .then((d) => d.json())
      .then((res) => {
        const response = res?.response?.data;
        const expenseCategory = response?.expense_category;
        const formattedExpenseData = Object.entries(expenseCategory)?.map(
          ([key, value]) => {
            const option = Object.entries(value)?.map(([id, name]) => {
              return { id, name };
            });
            return { label: key, value: option };
          }
        );
        setExpenseCategoryList(formattedExpenseData);
      })
      .catch((err) => console.log("e", err));
  };

  const getUMOData = () => {
    const payload = {
      vendor_id: vendorId,
    };
    fetch(process.env.REACT_APP_API_URL + "/api/vendorpo/staticDataList", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((res) => {
        const umo = res?.response?.data;
        const formattedUMO = Object.entries(umo)?.map(([key, value]) => ({
          id: key,
          name: value,
        }));
        const nos = formattedUMO.filter(each => each.name == 'Nos')
        if(nos.length == 1){
          setSelectedUom(nos[0])
        }
        setUomList(formattedUMO);
      })
      .catch((err) => console.log("e", err));
  };

  useEffect(() => {
    const formattedDetails = itemDetails.map( item => {
      return {...item, uom: selectedUom? selectedUom: ''}
    })
    setItemDetails(formattedDetails)

  },[selectedUom])


  const getBillDetailsByPoId = () => {
    const payload = {
      community_id: commID,
      po_id: poId,
    };
    setInitialLoader(true);
    fetch(process.env.REACT_APP_API_URL + "/api/vendorpo/poDetailsByPoID", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((res) => {
        setInitialLoader(false);
        const response = res.response?.data;
        setLeftPoAmount(response?.left_po_amount);
        setPoNumber(response?.po_display_number);
        const itemData = response?.po_items;
        const availableQtyExpenceCategory = {}
        const formattedData = itemData?.map((each, i) => {
          const decimals = each.unit_price.split(".")[1].length;
          const parsedRemainQty = Number(each?.remain_qty);
          const parsedUnitPrice = Number(each.unit_price);
          const parsedDiscount = Number(each.discount_amount);
          const totalUnitPrice =
            parsedRemainQty * parsedUnitPrice - parsedDiscount;
          const vatAmount = (totalUnitPrice / 100) * Number(each.tax);
          if (parsedRemainQty > 0) {
            setSelectableCateories((prev) => [...prev, each?.category_id]);
            if(availableQtyExpenceCategory[each.category_id]){
              availableQtyExpenceCategory[each.category_id] = availableQtyExpenceCategory[each.category_id] + each.parsedRemainQty
            }else{
              availableQtyExpenceCategory[each.category_id] = parsedRemainQty
            }

            return {
              id: createId(),
              poItemId: each?.po_item_id ? each.po_item_id : '0',
              expenseCategory: { id: each?.category_id, name: "" },
              itemName: each.item,
              uom: { id: each.uom, name: "" },
              quantity: parsedRemainQty < 0 ? 0 : parsedRemainQty,
              unitPrice: each.unit_price,
              discountAmount: each.discount_amount,
              totalUnitPrice:
                each.total_unit_price ?? totalUnitPrice.toFixed(decimals),
              vat: each.tax,
              vatAmount:
                each.tax_amount ?? vatAmount.toFixed(decimals),
              totalPrice:
                each.amount ??
                (totalUnitPrice + vatAmount).toFixed(decimals),
              remainQty: parsedRemainQty,
            };
          }
        });
        if (formattedData.filter(Boolean).length == 0) {
          toast.error(
            "Maximum quantity limit reached. Please reduce item quantities before creating a bill from this PO."
          );
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        }
        const poLineItems = formattedData.filter(Boolean);
        setItemDetails(calculatedItemDetails(poLineItems));
        setCategoryAvailableQty(availableQtyExpenceCategory)
      })
      .catch((err) => console.log("e", err));
  };

  const getBillDetailsById = () => {
    const payload = {
      community_id: commID,
      bill_id: billId,
    };
    setInitialLoader(true);
    fetch(
      process.env.REACT_APP_API_URL + "/api/vendorpo/vendorBillsDetailbyID",
      {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "content-type": "application/json" },
      }
    )
      .then((d) => d.json())
      .then((res) => {
        setInitialLoader(false);
        const response = res.response?.data;
        setBillNumber(response?.bill_number);
        setBillDate(response.bill_date?.split(" ")?.[0]);
        setBillTimeStamp(response.bill_date?.split(" ")?.[1])
        setDueDate(response.due_date?.split(" ")?.[0]);
        setComment(response?.description);
        setNotes(response?.bill_additional_notes);
        setLeftPoAmount(response?.left_po_amount);
        setPoNumber(response?.po_display_number);

        const itemData = response?.vendor_bill_items;
        const availableQtyExpenceCategory = {}



        const formattedData = itemData?.map((each, i) => {
          const parsedRemainQty = Number(each?.remain_qty);
          const parsedQuantity = Number(each.quantity)

          setSelectableCateories((prev) => [
            ...prev,
            each?.expense_category_id,
          ]);
          if(availableQtyExpenceCategory[each.expense_category_id]){
            availableQtyExpenceCategory[each.expense_category_id] = availableQtyExpenceCategory[each.expense_category_id] + (each.parsedRemainQty + parsedQuantity)
          }else{
            availableQtyExpenceCategory[each.expense_category_id] = parsedRemainQty + parsedQuantity
          }
          return {
            id: createId(),
            poItemId: each?.po_item_id ? each.po_item_id : '0',
            expenseCategory: { id: each?.expense_category_id, name: "" },
            itemName: each.item,
            uom: { id: each.uom, name: "" },
            quantity: parseInt(each.quantity),
            unitPrice: each.unit_price,
            discountAmount: each.discount_amount,
            totalUnitPrice: each.total_unit_price,
            vat: each.vat_percentages,
            vatAmount: each.vat_amount,
            totalPrice: each.total_amount,
            remainQty:
              parseInt(each?.remain_qty) < 0
                ? 0
                : parseInt(each?.remain_qty) + parseInt(each.quantity),
          };
        });
        const fomrattedAttachments = response?.documents?.map((each) => {
          return {
            // unique: 'uniqueAttachment',
            path: each?.path,
            url: each?.file_download_url,
            name: each?.orig_name,
            file_size: each?.file_size,
            file_type: each?.file_type,
          };
        });
        if (response?.po_id) {
          setShowPoInput(true);
          setPurchaseOrderId(response?.po_id);
        }
        if (fomrattedAttachments) {
          setEditApiAttachments(fomrattedAttachments);
        }
        if (formattedData) {
          setItemDetails(calculatedItemDetails(formattedData));
        }
        setCategoryAvailableQty(availableQtyExpenceCategory)

        if (response?.left_po_amount) {
          setLeftPoAmount(response.left_po_amount);
        }
        if (response?.po_display_number) {
          poNumner(response.po_display_number);
        }
      })
      .catch((err) => console.log("e", err));
  };

  useEffect(() => {
    counter = 2;

    getMappedCommunities();
    getUMOData();
    if (poId) {
      setShowPoInput(true);
      getBillDetailsByPoId();
    }
    if (billId) {
      getBillDetailsById();
    }
  }, []);

  useEffect(() => {
    if (selectedCommunityOption?.id) {
      getExpenseCategory();
    }
  }, [selectedCommunityOption]);

  const handleIconClick = () => {
    if (filePickerRef.current) {
      filePickerRef.current.click();
    }
  };

  const downloadFile = (attachment) => {
    window.open(attachment.url, "_blank", "noopener,noreferrer");
  };

  const handleFileChange = (event) => {
    const name = "attachBill";
    const file = Array.from(event.target.files);
    const existingAttachments = [...editApiAttachments, ...documents];

    if (file.length === 0) {
      return;
    }

    let filesSize = 0;
    for (let i = 0; i < file.length; i++) {
      filesSize = filesSize + file[i].size;
    }

    const existingFilesSize = existingAttachments.reduce((total, each) => {
      return total + (Number(each?.file_size) || 0);
    }, 0);

    if (existingFilesSize + filesSize > MAX_FILE_SIZE_MB * 1024 * 1024) {
      toast.error(
        `Total file size exceeds the maximum limit of ${MAX_FILE_SIZE_MB} MB.`
      );
      event.target.value = "";
      return;
    }
    if (existingAttachments.length + file.length > 5) {
      toast.error("You can only upload up to 5 files");
      event.target.value = "";
      return;
    }
    // const formData = new FormData();
    // formData.append("file", file[0]);
    const formData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formData.append("file[]", file[i]);
    }
    setIsLoading(true);
    setDocumentUploading(true);

    fetch(process.env.REACT_APP_API_URL + "/api/FileUploadmultiple", {
      method: "POST",
      body: formData,
    })
      .then((d) => d.json())
      .then((res) => {
        const fomrattedData = res?.map((each) => {
          return {
            unique: name,
            path: each.path,
            url: each.url,
            name: each.name,
            file_size: each?.size,
            file_type: each?.type,
          };
        });

        setDocuments((prevDocuments) => [...prevDocuments, ...fomrattedData]);
        setIsLoading(false);
        setDocumentUploading(false);
        event.target.value = "";
      })
      .catch((error) => {
        setIsLoading(false);
        setDocumentUploading(false);
        event.target.value = "";
        toast.error(
          "Upload failed due to server error. Please try again later"
        );
        console.log(error);
      });
  };
  const bytesToKB = (bytes) => {
    return (bytes / 1024).toFixed(2) + " KB";
  };

  const removeItem = (item) => {
    const filteredData = itemDetails.filter((each) => each.id != item.id);
    setItemDetails(calculatedItemDetails(filteredData));
  };

  const handleSubmit = () => {
    toast.dismiss();
    const errors = [];
    if (!selectedCommunityOption?.id) {
      errors.push("Community field is required");
    }
    if (!vendorName) {
      errors.push("Vendor name field is required");
    }
    if (!billNumber) {
      errors.push("Bill Number field is required");
    }
    if (!billDate) {
      errors.push("Bill Date field is required");
    }
    if (!dueDate) {
      errors.push("Due Date field is required");
    }
    if (!comment) {
      errors.push("Bill description is required");
    }
    if (!billId && Object.keys(documents).length === 0) {
      errors.push("Bill attachment is required");
    }
    const categoryEnteredQty = {}

    itemDetails.forEach((each, index) => {
      if (!each.itemName) {
        errors.push(`Item name in row #${index + 1} field is required`);
      }
      if (!each.quantity) {
        errors.push(`Quantity in row #${index + 1} field is required`);
      }
      if (!each.unitPrice) {
        errors.push(
          `Unit price in row #${index + 1} field is filed is required`
        );
      }
      if (!each?.uom?.name) {
        errors.push(`UOM field in row #${index + 1} is required`);
      }
      if(categoryEnteredQty[each?.expenseCategory?.id]){
        categoryEnteredQty[each?.expenseCategory?.id] = categoryEnteredQty[each.expenseCategory?.id] + each?.quantity
      }else{
        categoryEnteredQty[each?.expenseCategory?.id] = each?.quantity

      }
    });

    Object.entries(categoryEnteredQty).forEach(([key, value]) => {
      if(value > categoryAvailableQty[key]){
        const categoryNameArray = getFilteredCategoriesFlat.map(categories => categories.value.filter(category => category.id === key))
        const categoryName = categoryNameArray.flat()[0].name
        errors.push(`${categoryAvailableQty[key]} available for the category ${categoryName}. Please reduce quantity to continue.`)
      }
    });

    if (errors.length > 0) {
      setErrorsArray(errors);
      window.scrollTo(0, 0);
    } else if (dueDate < billDate) {
      setErrorsArray([]);
      toast.error("Due date must be after the bill date");
    } else if (
      leftPoAmount &&
      Number(billTotals.grandTotal) > Number(leftPoAmount)
    ) {
      setErrorsArray([]);
      toast.error(
        "Bill amount can not be greater than Purchase Order amount. Please check and try again."
      );
    } else {
      setErrorsArray([]);
      setIsLoading(true);
      const formattedItemDetails = itemDetails.map((each) => {
        return {
          expense_category_id: each?.expenseCategory?.id,

          po_item_id: each?.poItemId,

          item_name: each?.itemName,

          uom: each?.uom?.id,

          quantity: each?.quantity,

          unit_price: each?.unitPrice,

          discount_amount: each?.discountAmount,

          total_unit_price: each?.totalUnitPrice,

          total_amount: each?.totalPrice,

          vat_percentages: each?.vat,

          vat_amount: each?.vatAmount,
        };
      });

      const payload = {
        user_id: userId,
        post_bill_id: billId,
        po_id: poId || purchaseOrderId,
        bill_number: billNumber,
        bill_date: billDate+' '+billTimeStamp,
        gross_amount: billTotals.grandTotal,
        bill_sub_amount: billTotals.billSubAmount,
        bill_vat_amount: billTotals.billVatAmount,
        bill_discount_amount: billTotals.billDiscountAmount,
        bill_amount: billTotals.grandTotal,
        notes: comment,
        vendor_id: vendorId,
        created_by: vendorId,
        community_id: selectedCommunityOption?.id,
        due_date: dueDate,
        document: documents,
        bills_items_array: formattedItemDetails,
        bill_additional_notes: notes,
      };

      fetch(process.env.REACT_APP_API_URL + "/api/vendorpo/storePoBill", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setIsLoading(false);
          if (res.status === true) {
            toast(`${res.message}`, {
              type: "success",
            });
            setItemDetails([item]);
            setTimeout(() => {
              navigate(-1);
            }, [1000]);
          } else {
            res.message.split("<br />").forEach((msg) => {
              if (msg.trim().length > 0) {
                toast(`${msg.trim()}`, {
                  type: "error",
                });
              }
            });
          }
        })
        .catch((err) => {
          console.log("e", err);
        });
    }
  };
  useEffect(() => {
    if (communitiesList.length) {
      const comm = communitiesList.filter((each) => each.id == commID);
      setSelectedCommunityOption(comm[0]);
    }
  }, [communitiesList.length]);

  // Re-apply community rounding when settings load. Totals come from billTotals (useMemo).
  // Intentionally omits itemDetails — line edits are handled in onChange via calculatedItemDetails.
  useEffect(() => {
    if (!selectedCommunityOption?.name) {
      return;
    }
    if (!itemDetails.some((each) => each?.quantity && each?.unitPrice)) {
      return;
    }
    const communityRoundOff = selectedCommunityOption?.roundOffNumber;
    const roundOffValue =
      communityRoundOff != null && communityRoundOff !== ""
        ? Number(communityRoundOff)
        : 2;
    setItemDetails((currentItems) => {
      const updatedItemData = currentItems.map((each) => {
        if (!each?.quantity || !each?.unitPrice) {
          return each;
        }
        const quantityValue = parseInt(each.quantity || 0, 10);
        const unitPriceValue = getDecimalValues(each.unitPrice || 0);
        const discountValue = getDecimalValues(each.discountAmount || 0);
        const totalUnitPriceValue = (
          quantityValue * unitPriceValue -
          discountValue
        ).toFixed(roundOffValue);
        const vatValue = getDecimalValues(each.vat || 0);
        const vatAmountValue = getDecimalValues(
          (+totalUnitPriceValue * +vatValue) / 100
        );
        const totalPriceValue = getDecimalValues(
          +totalUnitPriceValue + +vatAmountValue
        );
        return {
          ...each,
          quantity: quantityValue,
          unitPrice: unitPriceValue,
          discountAmount: discountValue,
          totalUnitPrice: totalUnitPriceValue,
          vat: vatValue,
          vatAmount: vatAmountValue,
          totalPrice: totalPriceValue,
        };
      });
      return updatedItemData;
    });
  }, [selectedCommunityOption?.name, selectedCommunityOption?.roundOffNumber]);

  useEffect(() => {
    if (uomList.length) {
      const newData = itemDetails?.map((each) => {
        return {
          ...each,
          uom: uomList.filter((uom) => uom?.id == each.uom?.id)[0],
        };
      });
      setItemDetails(newData);
    }
  }, [uomList.length, itemDetails?.[0]?.itemName]);

  useEffect(() => {
    if (expenseCategoryList.length) {
      const newData = itemDetails?.map((each) => {
        const matchingCategory = expenseCategoryList.find((category) =>
          category.value?.some((sub) => sub.id === each.expenseCategory?.id)
        );
        const refinedExpenseCategory = matchingCategory?.value?.find(
          (sub) => sub.id === each.expenseCategory?.id
        );
        return {
          ...each,
          expenseCategory: refinedExpenseCategory,
        };
      });
      setItemDetails(newData);
    }
  }, [expenseCategoryList.length, itemDetails?.[0]?.itemName]);

  const getAttachmentPath = (fileType) => {
    let imgPath = "";
    switch (fileType) {
      case "pdf":
        imgPath = "/svg/pdf-icon.svg";
        break;
      case "jpg":
        imgPath = "/svg/jpg-icon.png";
        break;
      case "jpeg":
        imgPath = "/svg/jpg-icon.png";
        break;
      case "xls":
        imgPath = "/svg/xls-icon.svg";
        break;
      case "xlsx":
        imgPath = "/svg/xls-icon.svg";
        break;
      case "png":
        imgPath = "/svg/png-icon.png";
        break;
      case "svg":
        imgPath = "/svg/svg-icon.svg";
        break;
      default:
        imgPath = "/svg/document-icon.svg";
        break;
    }
    return imgPath;
  };

  const getFilteredCategoriesFlat = useMemo(() => {
    if (!selectableCategories.length || !expenseCategoryList.length) return [];

    const idsSet = new Set(selectableCategories);

    return expenseCategoryList
      .map((group) => ({
        label: group.label,
        value: group.value.filter((category) => idsSet.has(category.id)),
      }))
      .filter((group) => group.value.length > 0);
  }, [selectableCategories, expenseCategoryList]);


  return (
    <div style={{ width: "94%" }}>
      {initialLoader && (
        <div className={styles.loaderContainer}>
          <i
            className="fa fa-spinner fa-spin "
            style={{ color: "var(--BaseDarkColor)", fontSize: "40px" }}
          ></i>
        </div>
      )}
      <Header
        title={billId ? "Edit Bill" : "Create Bill"}
        backNavigation={true}
      />
      {errorsArray.length > 0 && (
        <div className={styles.errorWrapper}>
          <div style={{ fontWeight: "600" }}>
            You seems to have missed or incorrectly entered some data. Please
            correct the following and re-submit:
          </div>
          {errorsArray.map((each, index) => (
            <div>{`${index + 1}. ${each}.`}</div>
          ))}
        </div>
      )}

      <div className={styles.main}>
        <div>
          <div className={styles.wrapperTop}>Basic Details</div>
          <div className={styles.wrapperBottom}>
            {showPoInput && (
              <div className={styles.inputLabelWrapper}>
                <p className={styles.label}>SELECT PO</p>
                <TextInput
                  height={38}
                  className={styles.textInput}
                  placeholder="Enter PO number"
                  name="poNumber"
                  value={poNumner}
                  disabled
                />
              </div>
            )}
            <div className={styles.inputLabelWrapper}>
              <p className={styles.label}>
                COMMUNITY<span>*</span>
              </p>
              <CustomSingleSelect
                options={communitiesList}
                selectedOption={selectedCommunityOption}
                setSelectedOption={setSelectedCommunityOption}
                height={38}
                disable={showPoInput ? true : false}
              />
            </div>
            <div className={styles.inputLabelWrapper}>
              <p className={styles.label}>
                VENDOR NAME<span>*</span>
              </p>
              <TextInput
                height={38}
                className={styles.textInput}
                placeholder="Enter Vendor Name"
                name="vendorName"
                value={vendorName}
                disabled
              />
            </div>
            <div className={styles.inputLabelWrapper}>
              <p className={styles.label}>
                BILL NUMBER<span>*</span>{" "}
                <Tooltip
                  content={
                    <Paragraph className={styles.tooltip}>
                      Separate each number with a comma as you enter them.
                    </Paragraph>
                  }
                  appearance="card"
                  position="right"
                  className={styles.customTooltip}
                >
                  <img
                    style={{ marginLeft: "5px", marginBottom: "5px" }}
                    src={IMAGE_PATH + "info-icon.svg"}
                    alt=""
                  />
                </Tooltip>
              </p>
              <TextInput
                height={38}
                className={styles.textInput}
                placeholder="Enter Bill Number"
                name="billNumber"
                value={billNumber}
                onChange={(e) => {
                  setBillNumber(e.target.value.trimStart());
                }}
                required
              />
            </div>
            <div className={styles.inputLabelWrapper}>
              <p className={styles.label}>
                BILL DATE<span>*</span>
              </p>

              <TextInput
                height={38}
                className={styles.textInput}
                type="date"
                placeholder="Select Date"
                name="billDate"
                value={billDate}
                onChange={(e) => {
                  const now = new Date();
                  setBillDate(e.target.value);
                  setBillTimeStamp(now.toTimeString().slice(0, 8))
                }}
                required
              />
            </div>
            <div className={styles.inputLabelWrapper}>
              <p className={styles.label}>
                DUE DATE<span>*</span>
              </p>
              <TextInput
                height={38}
                min={today}
                className={styles.textInput}
                type="date"
                placeholder="Select Date"
                name="dueDate"
                value={dueDate}
                onChange={(e) => {
                  setDueDate(e.target.value);
                }}
                required
              />
            </div>
            <div className={styles.inputLabelWrapper}>
              <p className={styles.label}>
                BILL DESCRIPTION<span>*</span>
              </p>

              <TextareaField
                className={styles.textInput}
                placeholder="Enter bill description"
                value={comment}
                onChange={(e) => setComment(e.target.value.trimStart())}
                marginBottom={0}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.main}>
        <div>
          <div className={styles.wrapperTop}>Add Details</div>
          <div className={`${styles.wrapperBottom} ${styles.noGap}`}>
            {itemDetails?.length == 0 ? (
              <p>
                Maximum quantity limit reached. Please reduce item quantities
                before creating a bill from this PO.
              </p>
            ) : (
              <>
                <div className={styles.tableWrapper}>
                  <table className={styles.tableMain}>
                    <thead>
                      <tr>
                        <th
                          className={styles.cellBorders}
                          style={{ padding: "0px 24px", width: "70px" }}
                        ></th>

                        <th
                          className={styles.cellBorders}
                          style={{ padding: "0px 24px" }}
                        >
                          <div>Sr.No.</div>
                        </th>

                        {showPoInput && (
                          <th className={styles.cellBorders}>
                            <div className={styles.tableInputWrapper}>
                              Expense Category
                              <span className={styles.star}>*</span>
                            </div>
                          </th>
                        )}
                        <th className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            Item Name<span className={styles.star}>*</span>
                          </div>
                        </th>
                        <th className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            UOM<span className={styles.star}>*</span>
                          </div>
                        </th>
                        <th className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            Quantity<span className={styles.star}>*</span>
                          </div>
                        </th>
                        <th className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            Unit Price(exc. of taxes)
                            <span className={styles.star}>*</span>
                          </div>
                        </th>
                        <th className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            Discount Amount
                          </div>
                        </th>
                        <th className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            Total Unit Price
                          </div>
                        </th>
                        <th className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>VAT%</div>
                        </th>
                        <th className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            VAT Amount
                          </div>
                        </th>
                        <th>
                          <div className={styles.tableInputWrapper}>
                            Total Price
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemDetails?.map((each, index) => {
                        return (
                          <tr className={styles.tableRow}>
                            <td
                              className={styles.cellBorders}
                              style={{ padding: "0px 24px", width: "70px" }}
                            >
                              {itemDetails.length > 1 && (
                                <img
                                  style={{
                                    height: "18px",
                                    width: "18px",
                                    cursor: "pointer",
                                  }}
                                  src={IMAGE_PATH + "minus_circle_icon.svg"}
                                  alt=""
                                  onClick={() => removeItem(each)}
                                />
                              )}
                            </td>
                            <td
                              className={styles.cellBorders}
                              style={{ padding: "0px 24px" }}
                            >
                              <div>
                                {index + 1 < 10 ? `0${index + 1}` : index + 1}
                              </div>
                            </td>

                            {showPoInput && (
                              <td className={styles.cellBorders}>
                                <div
                                  className={styles.tableInputWrapper}
                                  style={{ minWidth: "160px" }}
                                >
                                  <CategorySelect
                                    options={getFilteredCategoriesFlat}
                                    selectedOption={each?.expenseCategory}
                                    setSelectedOption={(data) =>
                                      onChangeUOMAndCategory(
                                        data,
                                        each.id,
                                        "expenseCategory"
                                      )
                                    }
                                    height={30}
                                    disable={true}
                                  />
                                </div>
                              </td>
                            )}
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <TextInput
                                  height={30}
                                  className={styles.textInput}
                                  placeholder=""
                                  name="itemName"
                                  value={each.itemName}
                                  onChange={(e) =>
                                    onChangeItemDetails(e, each.id)
                                  }
                                  required
                                  disabled={showPoInput}
                                />
                              </div>
                            </td>
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <CustomSingleSelect
                                  options={uomList}
                                  selectedOption={each?.uom}
                                  setSelectedOption={(data) =>
                                    onChangeUOMAndCategory(data, each.id, "uom")
                                  }
                                  height={30}
                                />
                              </div>
                            </td>
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <TextInput
                                  height={30}
                                  className={styles.textInput}
                                  placeholder=""
                                  name="quantity"
                                  value={each.quantity}
                                  onChange={(e) =>
                                    onChangeItemDetails(e, each.id)
                                  }
                                  required
                                  textAlign="right"
                                />
                              </div>
                            </td>
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <TextInput
                                  height={30}
                                  className={styles.textInput}
                                  placeholder=""
                                  name="unitPrice"
                                  value={each.unitPrice}
                                  onChange={(e) =>
                                    onChangeItemDetails(e, each.id)
                                  }
                                  required
                                  textAlign="right"
                                  disabled={showPoInput}
                                />
                              </div>
                            </td>
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <TextInput
                                  height={30}
                                  className={styles.textInput}
                                  placeholder=""
                                  name="discountAmount"
                                  value={each.discountAmount}
                                  onChange={(e) =>
                                    onChangeItemDetails(e, each.id)
                                  }
                                  required
                                  textAlign="right"
                                />
                              </div>
                            </td>
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <TextInput
                                  height={30}
                                  className={styles.textInput}
                                  placeholder=""
                                  name="totalUnitPrice"
                                  value={each.totalUnitPrice}
                                  onChange={(e) =>
                                    onChangeItemDetails(e, each.id)
                                  }
                                  required
                                  textAlign="right"
                                  disabled
                                />
                              </div>
                            </td>
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <TextInput
                                  height={30}
                                  className={styles.textInput}
                                  placeholder=""
                                  name="vat"
                                  value={each.vat}
                                  onChange={(e) =>
                                    onChangeItemDetails(e, each.id)
                                  }
                                  required
                                  textAlign="right"
                                  disabled={showPoInput}
                                />
                              </div>
                            </td>
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <TextInput
                                  height={30}
                                  className={styles.textInput}
                                  placeholder=""
                                  name="vatAmount"
                                  value={each.vatAmount}
                                  onChange={(e) =>
                                    onChangeItemDetails(e, each.id)
                                  }
                                  required
                                  textAlign="right"
                                  disabled
                                />
                              </div>
                            </td>
                            <td className={styles.cellBorders}>
                              <div className={styles.tableInputWrapper}>
                                <TextInput
                                  height={30}
                                  className={styles.textInput}
                                  placeholder=""
                                  name="totalPrice"
                                  value={each.totalPrice}
                                  onChange={(e) =>
                                    onChangeItemDetails(e, each.id)
                                  }
                                  required
                                  textAlign="right"
                                  disabled
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={showPoInput ? 10 : 9}></td>
                        <td
                          className={`${styles.cellBordersBottom} ${styles.grandTotal}`}
                        >
                          <div>
                            Grand Total (AED)
                          </div>
                        </td>
                        <td className={styles.cellBordersBottom}>
                          <div className={styles.tableInputWrapper}>
                            <TextInput
                              height={30}
                              className={styles.textInput}
                              placeholder=""
                              value={billTotals.grandTotal}
                              disabled
                              textAlign="right"
                            />
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                    <tfoot>
                      <tr>
                        <td colSpan={showPoInput ? 6 : 5}></td>
                        <td
                          className={`${styles.cellBordersBottom} ${styles.grandTotal}`}
                        >
                          <div className={styles.tableInputWrapper}>Total</div>
                        </td>
                        <td className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            <TextInput
                              height={30}
                              className={styles.textInput}
                              placeholder=""
                              value={billTotals.billDiscountAmount}
                              disabled
                              textAlign="right"
                            />
                          </div>
                        </td>
                        <td className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            <TextInput
                              height={30}
                              className={styles.textInput}
                              placeholder=""
                              value={billTotals.billSubAmount}
                              disabled
                              textAlign="right"
                            />
                          </div>
                        </td>
                        <td className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}></div>
                        </td>
                        <td className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}>
                            <TextInput
                              height={30}
                              className={styles.textInput}
                              placeholder=""
                              value={billTotals.billVatAmount}
                              disabled
                              textAlign="right"
                            />
                          </div>
                        </td>
                        <td className={styles.cellBorders}>
                          <div className={styles.tableInputWrapper}></div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                {!showPoInput && 
                <div className={styles.addItemMain}>
                  <Tooltip
                    content={
                      showPoInput ? (
                        <Paragraph className={styles.tooltip}>
                          Additional items cannot be added to Purchase Order
                          bills.
                        </Paragraph>
                      ) : (
                        ""
                      )
                    }
                    appearance="card"
                    position="right"
                    className={styles.customTooltip}
                  >
                    <div
                      className={styles.addItemWrapper}
                      onClick={plusAddItemDetails}
                    >
                      <img
                        style={{ height: "18px", width: "18px" }}
                        src={IMAGE_PATH + "add-item-icon.svg"}
                        alt=""
                      />
                      <div className={styles.addItemText}>Add item</div>
                    </div>
                  </Tooltip>
                </div>}
              </>
            )}
          </div>
        </div>
      </div>
      <div className={styles.main}>
        <div>
          <div className={styles.wrapperTop}>Attachments</div>
          <div className={styles.attachmentsWrapperBottom}>
            <div className={styles.attachmentsWrapper}>
              <div className={styles.imageWrapper}>
                {documentUploading && (
                  <i
                    className="fa fa-spinner fa-spin "
                    style={{
                      color: "var(--BaseDarkColor)",
                      marginRight: "10px",
                    }}
                  ></i>
                )}
                <img
                  src={IMAGE_PATH + "add-item-icon.svg"}
                  alt=""
                  isLoading
                  onClick={handleIconClick}
                  style={{ cursor: "pointer" }}
                />
                <input
                  type="file"
                  ref={filePickerRef}
                  onChange={handleFileChange}
                  accept=".pdf, .jpg, .png, .jpeg, .xlsx, .xls"
                  multiple={true}
                  style={{ display: "none" }}
                  disabled={documentUploading}
                />
              </div>
              {[...editApiAttachments, ...documents]?.map((each) => {
                const fileType = each?.name?.split(".")?.[1];
                const imgPath = getAttachmentPath(fileType);
                return (
                  <div className={styles.attachmentsMain}>
                    <img
                      src={imgPath}
                      alt=""
                      style={{ height: "36px", width: "36px" }}
                    />
                    <div className={styles.titleSizeWrapper}>
                      <div className={styles.docName}>{each.name}</div>
                      <div className={styles.docSize}>
                        {bytesToKB(each?.file_size)}
                      </div>
                    </div>
                    {billId && (
                      <div
                        className={styles.view}
                        onClick={() => downloadFile(each)}
                      >
                        view
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <p className={styles.attachmentInfo}>
              <img
                style={{ marginRight: "5px", marginBottom: "2px" }}
                src={IMAGE_PATH + "info-icon.svg"}
                alt=""
              />
              Maximum 5 files with a combined size of 25MB total
            </p>
          </div>
        </div>
      </div>
      <div className={styles.main}>
        <div>
          <div className={styles.wrapperTop}>Additional</div>
          <div className={styles.wrapperBottom}>
            <div style={{ width: "100%" }}>
              <div className={styles.comments}>Notes</div>
              <TextareaField
                placeholder="Add your notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value.trimStart())}
                marginBottom={0}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <CustomButton
          variant="outline"
          onClick={() => {
            navigate(-1);
          }}
        >
          Cancel
        </CustomButton>
        <CustomButton onClick={handleSubmit} disabled={isLoading}>
          {isLoading && (
            <i
              className="fa fa-spinner fa-spin "
              style={{ color: "white", marginRight: "10px" }}
            ></i>
          )}
          Submit
        </CustomButton>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default CreateBill;
